import { atom } from 'jotai';

export const stripeSuccessModalOpenAtom = atom(false);
